import Link from 'next/link'
import React, { ReactElement } from 'react'
import s from './TasteFuture.module.scss'
import { getFastlyUrl } from '@corratech/pylot-image'
import cn from 'classnames'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    children?: ReactElement[]
    childLength?: number
}
const TasteFutureCard = (props: WidgetConfiguration) => {
    const {
        widgetConfiguration: {
            'button-link': buttonlink,
            content,
            heading,
            image,
            'show-button': showButton,
            'text-color': textColor,
            'button-text': buttonText,
            'image-fastly-param': imageFastlyParam,
            'sub-heading': subHeading
        },
        childLength
    } = props

    const getfastlyConfig = () => {
        if (imageFastlyParam) {
            return JSON.parse(imageFastlyParam)
        }
        if (childLength === 2) {
            return { width: 624, height: 654 }
        }
        if (childLength === 3) {
            return { width: 410, height: 580 }
        }
        if (childLength === 4) {
            return { width: 302, height: 520 }
        }
    }
    const fastlyImageUrl = getFastlyUrl({
        src: image,
        ...getfastlyConfig()
    })

    return (
        <div
            className={cn(s.FutureCard, 'FutureCard')}
            style={{ '--text-color': textColor } as React.CSSProperties}
        >
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <img src={fastlyImageUrl} alt="future card" loading="lazy" />
            <div className={cn(s.allContent, 'allContent')}>
                <h3 className={s.cardHeader}>{heading}</h3>
                <p className={s.description}>{subHeading}</p>
                <span className={s.content}>{content}</span>
                {showButton && buttonlink && buttonText && (
                    <Link href={buttonlink} passHref>
                        <a className={s['buttonLink']}>{buttonText}</a>
                    </Link>
                )}
            </div>
        </div>
    )
}
export default TasteFutureCard
